import React from "react";
import { ArrowDown } from "./ArrowDown";
import { ArrowLeft } from "./ArrowLeft";
import { ArrowLink } from "./ArrowLink";
import { ArrowRight } from "./ArrowRight";
import { ArrowUp } from "./ArrowUp";
import { Cart } from "./Cart";
import { ChevronDown } from "./ChevronDown";
import { ChevronLeft } from "./ChevronLeft";
import { ChevronRight } from "./ChevronRight";
import { ChevronUp } from "./ChevronUp";
import { Close } from "./Close";
import { Facebook } from "./Facebook";
import { Instagram } from "./Instagram";
import { Link } from "./Link";
import { Linkedin } from "./Linkedin";
import { Mail } from "./Mail";
import { Phone } from "./Phone";
import { PhoneOutline } from "./PhoneOutline";
import { Pinterest } from "./Pinterest";
import { Play } from "./Play";
import { PlayNarrow } from "./PlayNarrow";
import { Seek } from "./Seek";
import { Twitter } from "./Twitter";
import { Youtube } from "./Youtube";

export const icons = Object.freeze({
  ArrowDown: <ArrowDown />,
  ArrowRight: <ArrowRight />,
  ArrowUp: <ArrowUp />,
  ArrowLink: <ArrowLink />,
  ArrowLeft: <ArrowLeft />,
  ChevronDown: <ChevronDown />,
  ChevronLeft: <ChevronLeft />,
  ChevronUp: <ChevronUp />,
  ChevronRight: <ChevronRight />,
  Close: <Close />,
  Cart: <Cart />,
  Facebook: <Facebook />,
  Instagram: <Instagram />,
  Link: <Link />,
  Linkedin: <Linkedin />,
  Mail: <Mail />,
  Phone: <Phone />,
  PhoneOutline: <PhoneOutline />,
  Pinterest: <Pinterest />,
  Play: <Play />,
  PlayNarrow: <PlayNarrow />,
  Seek: <Seek />,
  Twitter: <Twitter />,
  Youtube: <Youtube />,
});
